import React, {PureComponent} from "react";
import {connect} from "dva";
import {injectIntl,FormattedMessage} from "react-intl";
import "./LicensePage.less";
import {Input,Modal} from  'antd';
import { Btn } from '../../components/Widgets';

class LicensePage extends PureComponent {
  constructor() {
    super();
  }

  componentWillMount() {
  }

  render() {
    const {dispatch,intl} = this.props;
    const {data = ''} = this.props.license;
    return <div className="policy-manage">
      <div className="policy-item">
        <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="license_title"/>
          </span>
          <span className="search-line-subtitle">
            <FormattedMessage id="license_subtitle"/>
          </span>
        </div>
        <div className="notice-content">
          <div className="notice-item">
            <label>
              <FormattedMessage id="license_label"/>
            </label>
            <div className="notice-control">
              <div style={{width: '350px'}}>
                <Input
                  value={data}
                  onChange={e => {
                    dispatch({
                      type: 'license/update',
                      payload: {
                        data:e.target.value
                      }
                    });
                  }}
                />
              </div>
            </div>
            </div>
          <div className="operate_btn_div">
            <Btn
              primary
              onClick={() => {
                const promise = new Promise((resolve, reject) => {
                  dispatch({
                    type: 'license/updateLicenseInfo',
                    value:data,
                    resolve,
                    reject
                  });
                });
                promise.then(
                  () => {
                    Modal.success({
                      content: intl.formatMessage({id: 'index_save_success'})
                    });
                  },
                  msg => {
                    Modal.error({content: msg});
                  }
                );
              }}
            >
              <FormattedMessage id="policy_manage_btn_save"/>
            </Btn>
          </div>
        </div>
      </div>
    </div>
  }

}

const mapStateToProps = state => {
  const {license} = state;
  return {license};
};

export default connect(mapStateToProps)(injectIntl(LicensePage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/LicensePage.js